import React from 'react';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import AppHeader from './components/AppHeader.js'
import UploadDropZone from './components/UploadDropZone.js'
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Storage from './controllers/Storage.js'
import UploadController from './controllers/UploadController.js'
import AppController from "./controllers/AppController.js";

import UploadPageGrid from "./components/UploadPageGrid.js";

import ReviewPageGrid from "./components/ReviewPageGrid.js";
import ExpenseGrid from "./components/ExpenseGrid.js"
// eslint-disable-next-line
import ExpenseEditingPanel from './components/ExpenseEditingPanel.js'

import PropTypes from 'prop-types';
import { Menu, Item/*, Separator, Submenu, MenuProvider*/ } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';
import _ from './controllers/Utils.js'
// eslint-disable-next-line
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Form} from 'reactstrap';
import { ListGroup, ListGroupItem } from 'reactstrap';
import EditableGridSelectionStorage from './components/EditableGrideSelectionStorage.js'

const LocaleContext = React.createContext('US');

function HomePage() {
  return (<header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload. Test
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>);
}


const storage = new Storage();
storage.readLocalStorage();
const uploadController = new UploadController(storage);
const appController = new AppController(storage);

function AboutPage() {
  return (<div><h2>About</h2>
     <button type="button" className="btn btn-primary" onClick={()=>storage.resetUnsafe()}>Reset Unsafe</button>
</div>
    );
}

// class GridContextMenu extends React.Component {
//     constructor(props) {
//         super(props)
//         this.handleRowDelete = this.handleRowDelete.bind(this)
//         this.state = {
//         }
//     }
    
    

//     render () {
//         return (
//       <Menu id='grid_context_menu_id'>
//          <Item onClick={this.handleRowDelete}>Remove Row</Item>
//       </Menu>
//   );
//     }
// }

class ConfigurePage extends React.Component {
  constructor(props) {
    super(props)
    this.handleExpenseUpdate = this.handleExpenseUpdate.bind(this);
    this.handleExpenseDelete = this.handleExpenseDelete.bind(this);
    this.handleExpenseAdd = this.handleExpenseAdd.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.handleCreateExpenseModalClose = this.handleCreateExpenseModalClose.bind(this);
    this.handleCreateExpenseModalSubmit = this.handleCreateExpenseModalSubmit.bind(this);
    this.handleCreateExpenseTextChange = this.handleCreateExpenseTextChange.bind(this);

    this.state = {
      selectionStorage: new EditableGridSelectionStorage([this]),
      selectedVersion: 0
    }

  }

  handleExpenseUpdate(transaction, changed){
    let version = appController.updateExpense(transaction, changed);
    this.setState({version:version});
  }

  handleExpenseDelete({ props }){
    console.log(props.selected)
    let expenses = props.selected.map(function(index) {
      return storage.getStore().expenses.value[index].name;
    });
    let version = appController.deleteExpenses(expenses);
    this.setState({version:version});
    this.state.selectionStorage.resetSelection();
  }
  

  handleExpenseAdd() {
    this.setState({
      createExpenseDialogOpen: true,
      newExpenseName: 'New Expense'
    })
  }

  onSelectionChange() {
    this.setState({selectedVersion:this.state.selectedVersion+1});
  }

  handleCreateExpenseModalClose() {
    this.setState({
      createExpenseDialogOpen: false
    })
  }

  handleCreateExpenseModalSubmit() {
    if (this.state.newExpenseName) {
      let version = appController.addExpense(this.state.newExpenseName);
      this.setState({version:version});
      this.state.selectionStorage.resetSelection();
    }
    this.setState({
      createExpenseDialogOpen: false
    })

  }

  handleCreateExpenseTextChange(e) {
    this.setState({
      newExpenseName: e.target.value
    })
  }

  render () {
    console.log("render ConfigurePage")
    return (<div className="ConfigurePage">
        <div className="content mr-auto">
          <h3>Edit available expenses</h3>
          <div style={{width: "100%", height: "280px"}}>
            <ExpenseGrid expenses={storage.getStore().expenses.value}
                         version={storage.getStore().expenses.version}
                         onExpenseUpdate={this.handleExpenseUpdate}
                         onNewRowClick={this.handleExpenseAdd}
                         selectionStorage={this.state.selectionStorage}
                         menuId={"configure_expenses_grid_context_menu_id"}
            />
            <Menu id='configure_expenses_grid_context_menu_id'>
              <Item onClick={this.handleExpenseAdd}>New Expense</Item>
              <Item onClick={this.handleExpenseDelete} disabled={!this.state.selectionStorage.hasAnySelected()}>Remove Expense</Item>
            </Menu>
          </div>

          {/*<ExpenseEditingPanel appController={appController}/>*/}
        </div>

        <nav className="sidebar" >
            You can configure your view settings
        </nav>

        <Modal isOpen={this.state.createExpenseDialogOpen} toggle={this.handleCreateExpenseModalClose}>
          <ModalHeader toggle={this.handleCreateExpenseModalClose}>Create an Expense</ModalHeader>
          <ModalBody>
            Enter Expense Label
            <Input name="text" value={this.state.newExpenseName} onChange={this.handleCreateExpenseTextChange}/>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleCreateExpenseModalSubmit}>Create</Button>
            <Button color="secondary" onClick={this.handleCreateExpenseModalClose}>Close</Button>
          </ModalFooter>
        </Modal>
    </div> );
  }
}


class UploadPage extends React.Component {
    constructor(props) {
        super(props)
        this.handleFileUpload = this.handleFileUpload.bind(this)
        this.handleTransactionUpdate = this.handleTransactionUpdate.bind(this)
        this.handleTransactionDelete = this.handleTransactionDelete.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleClearAll = this.handleClearAll.bind(this);
        this.isDeleteDisabled = this.isDeleteDisabled.bind(this)
        this.grid = React.createRef() 
        this.state = {
        }
    }
    
    handleFileUpload(event){
      console.log("handleFileUpload:" + event.target.result);
      let version = uploadController.parseFileContent(event.target.result)
      this.setState({version:version});

    }

    handleTransactionUpdate(transaction, changed){
      let version = uploadController.updatePendingTransaction(transaction, changed);
      this.setState({version:version});
    }


    handleSave() {
      let version = uploadController.commitPendingTransactions();
      this.setState({version:version});
    }

    handleClearAll() {
      let version = uploadController.clearAllPendingTransactions();
      this.setState({version:version});
    }


    handleTransactionDelete({ props }){
      console.log(props.selected)
      let pendingTransactions;
      if (!props.selectedRows){
        pendingTransactions = props.selected.map(function(index) {
          return storage.getStore().pendingTransactions.value[index].uuid;
        });
      } else {
        pendingTransactions = props.selected.map(function(row) {
          return row.uuid;
        });
      }
      let version = uploadController.deletePendingTransactions(pendingTransactions);
      this.setState({version:version});
      this.grid.current.resetSelection();
    }

    isDeleteDisabled({ props }){
      return !props.selected || !props.selected.length
    }

    // onContextMenu(e) {
    //     e.preventDefault();
    //     contextMenu.show({
    //       id: this.props.menuId,
    //       event: e,
    //       props: {
    //         selected: [...this.state.selected]
    //       }
    //     });
      

    render () {
      console.log("render UploadPage")
      return (<div className="UploadPage">
          <div className="content mr-auto">
            <UploadPageGrid pendingTransactions={storage.getStore().pendingTransactions.value} 
                            transactionSplits={storage.getStore().transactionSplits.value}
                            version={storage.getStore().pendingTransactions.version}
                            onTransactionUpdate={this.handleTransactionUpdate}
                            menuId={"review_grid_context_menu_id"}
                            onRowClick={this.handleRowClick}
                            ref={this.grid}/>
            <Menu id='review_grid_context_menu_id'>
               <Item onClick={this.handleTransactionDelete} disabled={this.isDeleteDisabled}>Remove Row</Item>
            </Menu>
          </div>

          <nav className="sidebar" >
              <UploadDropZone onFileLoad={this.handleFileUpload}></UploadDropZone>

              <button type="button" className="btn btn-primary" onClick={this.handleSave}>Save &gt;&gt;</button>
              <Button color="link" onClick={this.handleClearAll}>Clear All</Button>
          </nav>
      </div> );
    }
}



class ReviewPage extends React.Component {
    constructor(props) {
        super(props);
        this.handleTransactionUpdate = this.handleTransactionUpdate.bind(this);
        this.handleTransactionDelete = this.handleTransactionDelete.bind(this)
        this.asyncProcessOfPendingTransactions = this.asyncProcessOfPendingTransactions.bind(this);
        this.handleTransactionAdd = this.handleTransactionAdd.bind(this);
        this.handleNewRowClick = this.handleNewRowClick.bind(this);
        this.handleExportModalClose = this.handleExportModalClose.bind(this);
        this.handleExportModalOpen = this.handleExportModalOpen.bind(this);
        this.handleImportModalClose = this.handleImportModalClose.bind(this);
        this.handleImportModalOpen = this.handleImportModalOpen.bind(this);
        this.handleImportModalSubmit = this.handleImportModalSubmit.bind(this);
        this.handleImportTextChange = this.handleImportTextChange.bind(this);
        this.handleRestoreBackupModalClose = this.handleRestoreBackupModalClose.bind(this);
        this.handleRestoreBackupModalOpen = this.handleRestoreBackupModalOpen.bind(this);
        this.handleRestoreBackupModalSubmit = this.handleRestoreBackupModalSubmit.bind(this);
        this.handleRestoreBackupSelectionChange = this.handleRestoreBackupSelectionChange.bind(this);
        this.handleResetModalClose = this.handleResetModalClose.bind(this);
        this.handleResetModalOpen = this.handleResetModalOpen.bind(this);
        this.handleResetModalSubmit = this.handleResetModalSubmit.bind(this);
        
        this.handleShowSubtotal = this.handleShowSubtotal.bind(this);
        this.handleShowSubtotalModalClose = this.handleShowSubtotalModalClose.bind(this);

        this.grid = React.createRef();
        this.state = {
          selectionStorage: new EditableGridSelectionStorage([this]),
          selectedVersion: 0,
          exportDialogOpen: false,
          importDialogOpen: false
        }
    }
    
    handleTransactionUpdate(transaction, changed){
      let version = appController.updateTransaction(transaction, changed);
      this.setState({version:version});
    }

    // shouldComponentUpdate(nextProps, nextState) { 
    //   if (!storage.getStore().version || nextState.version < storage.getStore().transactions.version 
    //     || nextState.version < storage.getStore().expenses.version ) { 
    //     return true;
    //   }
    //   return false;
    // }
    asyncProcessOfPendingTransactions(){
      let version = appController.processPendingTransactions();
      this.setState({lastProcessedVersion:version});
    }

    handleTransactionDelete({ props }){
      console.log(props.selected)
      let transactions = props.selected.map(function(index) {
        return storage.getStore().transactions.value[index].uuid;
      });
      let version = appController.deleteTransactions(transactions);
      this.setState({version:version});
      this.state.selectionStorage.resetSelection();
    }


    handleTransactionAdd({ props }) {
      let trExample = props.selected && props.selected.length? storage.getStore().transactions.value[props.selected[0]] : null
      let date = trExample? trExample.date : _.getUTCTime(new Date());
      let version = appController.addTransaction(date);
      this.setState({version:version});
      this.state.selectionStorage.resetSelection();
    }

    handleShowSubtotal({ props }) {
      console.log(props.selected)
      let transactionIndex = Math.max(...props.selected)
      let subtotal = appController.getSubTotal(transactionIndex);
      let expenses = storage.getStore().expenses.value;
      this.setState({
        showSubtotalDialogOpen: true,
        subtotal: subtotal,
        expenses: expenses
      })
    }
  
    handleShowSubtotalModalClose() {
      this.setState({
        showSubtotalDialogOpen: false
      })
    }

    handleNewRowClick() {
      let version = appController.addTransaction(_.getUTCTime(new Date()));
      this.setState({version:version});
      this.state.selectionStorage.resetSelection();
    }

    onSelectionChange() {
      this.setState({selectedVersion:this.state.selectedVersion+1});
    }

    handleExportModalOpen() {
      this.setState({
        exportDialogOpen: true,
        exportedJson: storage.exportAsJson()
      })
    }

    handleExportModalClose() {
      this.setState({
        exportDialogOpen: false
      })
    }


    handleRestoreBackupModalOpen() {
      this.setState({
        restoreBackupDialogOpen: true,
        selectedBackup: ''
      })
    }

    handleRestoreBackupModalClose() {
      this.setState({
        restoreBackupDialogOpen: false
      })
    }

    handleRestoreBackupModalSubmit() {
      if (this.state.selectedBackup) {
        storage.restoreBackup(this.state.selectedBackup)
      }
      this.setState({
        restoreBackupDialogOpen: false
      })

    }

    handleRestoreBackupSelectionChange(e) {
      this.setState({
        selectedBackup: e.target.dataset.value
      })
    }

    handleImportModalOpen() {
      this.setState({
        importDialogOpen: true,
        exportedJson: ''
      })
    }

    handleImportModalClose() {
      this.setState({
        importDialogOpen: false
      })
    }

    handleImportModalSubmit() {
      if (this.state.exportedJson) {
        storage.importFromJson(this.state.exportedJson)
      }
      this.setState({
        importDialogOpen: false
      })

    }

    handleImportTextChange(e) {
      this.setState({
        exportedJson: e.target.value
      })
    }


    handleResetModalOpen() {
      this.setState({
        resetDialogOpen: true
      })
    }

    handleResetModalClose() {
      this.setState({
        resetDialogOpen: false
      })
    }

    handleResetModalSubmit() {
      storage.resetUnsafe();
      this.setState({
        resetDialogOpen: false
      })

    }


    render () {
        if (this.state.lastProcessedVersion !== storage.getStore().version) {
          // transactions were changed by another process/controller
          // need to make sure that all records are up to date
          setTimeout(this.asyncProcessOfPendingTransactions, 0);
        }
        return (<div className="UploadPage">
            <div className="content mr-auto">
              <ReviewPageGrid transactions={storage.getStore().transactions.value}
                transactionSplits={storage.getStore().transactionSplits.value}
                onTransactionUpdate={this.handleTransactionUpdate}
                onNewRowClick={this.handleNewRowClick}
                selectionStorage={this.state.selectionStorage}
                expenses={storage.getStore().expenses.value}
                totalCounts={appController.getTotalCounts()}
                menuId={"review_grid_context_menu_id"}
                ref={this.grid}
                />
              <Menu id='review_grid_context_menu_id'>
                <Item onClick={this.handleTransactionAdd}>New Record</Item>
                <Item onClick={this.handleTransactionDelete} disabled={!this.state.selectionStorage.hasAnySelected()}>Remove Record</Item>
                <Item onClick={this.handleShowSubtotal} disabled={!this.state.selectionStorage.hasAnySelected()}>Show SubTotal</Item>
              </Menu>
            </div>

            <nav className="sidebar" >
                You {storage.getStore().transactions.value.length} records in total. 
                Your actions will be here
                {/*<Button color="danger" onClick={toggle}>{buttonLabel}</Button>*/}
                <Button color="link" onClick={this.handleExportModalOpen}>Export...</Button>
                <Button color="link" onClick={this.handleImportModalOpen}>Import...</Button>
                <Button color="link" onClick={this.handleRestoreBackupModalOpen}>Restore from Backup...</Button>
                <Button color="link" onClick={this.handleResetModalOpen}>Reset...</Button>
            </nav>

            <Modal isOpen={this.state.exportDialogOpen} toggle={this.handleExportModalClose}>
              <ModalHeader toggle={this.handleImportModalClose}>Modal title</ModalHeader>
              <ModalBody>
                <Input type="textarea" name="text" id="exampleText" value={this.state.exportedJson} readOnly/>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.handleExportModalClose}>Close</Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.importDialogOpen} toggle={this.handleImportModalClose}>
              <ModalHeader toggle={this.handleImportModalClose}>Modal title</ModalHeader>
              <ModalBody>
                <Input type="textarea" name="text" id="exampleText" value={this.state.exportedJson} onChange={this.handleImportTextChange}/>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.handleImportModalSubmit}>Submit</Button>
                <Button color="secondary" onClick={this.handleImportModalClose}>Close</Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.restoreBackupDialogOpen} toggle={this.handleRestoreBackupModalClose}>
              <ModalHeader toggle={this.handleRestoreBackupModalClose}>Modal title</ModalHeader>
              <ModalBody>
                <ListGroup>
                  { storage.index && storage.index.allVersions && storage.index.allVersions.map((item)=>{
                      return (<ListGroupItem active={this.state.selectedBackup===item} tag="button" onClick={this.handleRestoreBackupSelectionChange} data-value={item} key={item} action >{item}</ListGroupItem>
                      )
                  })}
                </ListGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.handleRestoreBackupModalSubmit}>Restore</Button>
                <Button color="secondary" onClick={this.handleRestoreBackupModalClose}>Close</Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.resetDialogOpen} toggle={this.handleResetModalClose}>
              <ModalHeader toggle={this.handleResetModalClose}>Reset confirmation</ModalHeader>
              <ModalBody>
                Please confirm that you want to reset
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.handleResetModalSubmit}>Reset</Button>
                <Button color="primary" onClick={this.handleResetModalClose}>Close</Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.showSubtotalDialogOpen} toggle={this.handleShowSubtotalModalClose}>
              <ModalHeader toggle={this.handleShowSubtotalModalClose}>Subtotal up until selected item</ModalHeader>
              <ModalBody>
                <ListGroup className="list-group">
                  {this.state.expenses && this.state.expenses.map((item) => (
                    <ListGroupItem className="list-group-item">
                      {item.label}:{this.state.subtotal[item.name]}
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </ModalBody>
            </Modal>
        </div> );
    }
}

function App() {
  console.log("render App")
  return (
    <LocaleContext.Provider value="US">   
        <Router >
          <div className="App">
            <AppHeader/>
            <Switch>
              <Route path="/" exact component={HomePage} />
              <Route path="/about/" component={AboutPage} />
              <Route path="/upload/" component={UploadPage} />
              <Route path="/review/" component={ReviewPage} />
              <Route path="/configure/" component={ConfigurePage} />
              <Route render={() => "404 Not found"}/>
            </Switch>
          </div>
        </Router>
      </LocaleContext.Provider>
  );
}


class AppStorage extends React.Component {
    constructor(props) {
        super(props)
        this.handleLocalStorageUpdate = this.handleLocalStorageUpdate.bind(this)
        this.state = {
        }
    }
    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('localStorage', this.handleLocalStorageUpdate)
        }
    }
    componentWillUnmount(){
        if (typeof window !== 'undefined') {
            window.removeEventListener('localStorage', this.handleLocalStorageUpdate)
        }
    }
    
    handleLocalStorageUpdate(){
      this.setState({version:storage.getStore().version});
    }
    render () {
        return this.props.children;
    }
}

AppStorage.propTypes = {
  children: PropTypes.node.isRequired
};

export default App;
